import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed }                      from '@ngneat/until-destroy';
import { Observable, Subject }                               from "rxjs";
import { map, takeUntil }       from "rxjs/operators";
import { DataTarificationPhaseB }                            from 'src/app/components/main/oav-phase-b/preconisation/dataTarificationPhaseB';
import { UnsubscribeOnDestroy } from 'src/app/shared/utils/unsubscribeOnDestroy';
import { FormuleProductEnum }   from "@shared/constants/formule-product.enum";
import { KeyValue }             from "@angular/common";
import { LetDirective }         from "@ngrx/component";
import { CONSTANTS }            from "@shared/constants/constants";

const TEXTE_INTO = {
  [FormuleProductEnum.FORMULE_GROUPAMA_SERENITE_OBSEQUES]: {
    key: "La prévoyance n’a désormais plus de secret pour vous!(1)<br> Après avoir réalisé votre bilan personnalisé, découvrez nos assurances prévoyance et les montants adaptés à votre profil.",
    value: "Découvrez ci-dessous votre approche tarifaire(1) :"
  },
  [FormuleProductEnum.FORMULE_GROUPAMA_SECURITE]: {
    key: "La prévoyance n’a désormais plus de secret pour vous!(1)<br> Après avoir réalisé votre bilan personnalisé, découvrez nos assurances prévoyance et les montants adaptés à votre profil.",
    value: "Découvrez ci-dessous votre approche tarifaire(1) :"
  },
  [FormuleProductEnum.FORMULE_GROUPAMA_GAV]: {
    key: "La prévoyance n’a désormais plus de secret pour vous!(1)<br> Après avoir réalisé votre bilan personnalisé, découvrez nos assurances prévoyance et les montants adaptés à votre profil.",
    value: "Découvrez ci-dessous votre approche tarifaire(1) :"
  },
  [CONSTANTS.DEFAULT]: {
    key: "Pour répondre à chaque situation et à chaque budget, nous vous <br> proposons de comparer différents niveaux  de couverture.",
    value: "Cochez ou décochez les cases produits pour ajuster votre tarif (1) :"
  }
};


@UntilDestroy()
@Component({
  selector: "app-oav-text-preco",
  templateUrl: "./oav-text-preco.component.html",
  styleUrls: ["./oav-text-preco.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    LetDirective
  ],
  providers: []
})
export class OavTextPrecoComponent implements OnInit {
  @Input()
  selectDatasTarificationPhaseB$: Observable<DataTarificationPhaseB[]>;

  public text$: Subject<KeyValue<string, string>>;

  constructor() {
    this.text$ = new Subject<KeyValue<string, string>>();
  }

  ngOnInit(): void {
    const _self = this;
    _self.selectDatasTarificationPhaseB$.pipe(
      untilDestroyed(this),
      map(ar => {
        const nbSelected = ar.filter(a => a.check);
        let formuleSelected = nbSelected.length === 1 ? nbSelected[0].id : CONSTANTS.DEFAULT;
        this.text$.next(TEXTE_INTO[formuleSelected] || TEXTE_INTO[CONSTANTS.DEFAULT]);
      })
    ).subscribe();
  }
}
